import { SimpleSelectOptionType } from '@epicuro-next/features/landing-panel';

const days = [
  { name: '30 days', value: '30' },
  { name: '60 days', value: '60' },
  { name: '90 days', value: '90' },
];

export const dayRangeSelectOptions: SimpleSelectOptionType[] = [];
for (const day of days) {
  dayRangeSelectOptions.push({
    value: day.value,
    displayValue: day.name,
  });
}
